import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';
import { BoxComponent, ButtonComponent, DividerComponent } from '@recruitee/user-interface';

import { AsyncJobsProgressDisplayModule } from '../async-jobs-progress-display/async-jobs-progress-display.module';
import { AsyncJobsDialogComponent } from './async-jobs-dialog.component';

@NgModule({
  declarations: [AsyncJobsDialogComponent],
  imports: [
    AsyncJobsProgressDisplayModule,
    BoxComponent,
    ButtonComponent,
    CommonModule,
    DividerComponent,
    I18nModule,
  ],
})
export class AsyncJobsDialogModule {}
